'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postNotification = postNotification;
exports.removeNotification = removeNotification;

var _ActionTypes = require('./ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function postNotification(notification) {
  return {
    type: _ActionTypes2.default.ADD_NOTIFICATION,
    payload: notification
  };
}

function removeNotification(id) {
  return {
    type: _ActionTypes2.default.REMOVE_NOTIFICATION,
    payload: {
      id: id
    }
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ReduxMessenger/static-2.618/js/actions/NotificationActions.js
// module id = 470
// module chunks = 0